// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.res.mjs";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Error$LiteracyplanetClientErrors from "@literacyplanet/client-errors/src/Error.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as ProfileData$LiteracyplanetClientSxEntry from "./ProfileData.res.mjs";
import * as CobraContainer$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/CobraContainer.res.mjs";
import * as KudosMutations$LiteracyplanetClientSxEntry from "./KudosMutations.res.mjs";
import * as ProfileTypesCobra$LiteracyplanetClientSxEntry from "./ProfileTypesCobra.res.mjs";

var defaultCb = {
  thumbsUp: "NotCalled",
  highFive: "NotCalled"
};

function useSocialCallbacks(userId, state) {
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var match = React.useState(function () {
        return defaultCb;
      });
  var setCallbackbState = match[1];
  var cbState = match[0];
  var giveHighFive = KudosMutations$LiteracyplanetClientSxEntry.useHighFive();
  var giveThumbsUp = KudosMutations$LiteracyplanetClientSxEntry.useThummbsUp();
  var onProfileSendHighFive = async function (param) {
    if (userId === undefined) {
      return ;
    }
    try {
      setCallbackbState(function (param) {
            return defaultCb;
          });
      await giveHighFive(userId, param.reason);
      return setCallbackbState(function (param) {
                  return {
                          thumbsUp: "NotCalled",
                          highFive: "Ok"
                        };
                });
    }
    catch (exn){
      return setCallbackbState(function (state) {
                  return {
                          thumbsUp: state.thumbsUp,
                          highFive: "Failed"
                        };
                });
    }
  };
  var onProfileSendThumbsUp = async function (params) {
    if (userId === undefined) {
      return ;
    }
    try {
      setCallbackbState(function (param) {
            return defaultCb;
          });
      await giveThumbsUp(userId);
      return setCallbackbState(function (param) {
                  return {
                          thumbsUp: "Ok",
                          highFive: "NotCalled"
                        };
                });
    }
    catch (exn){
      return setCallbackbState(function (state) {
                  return {
                          thumbsUp: "Failed",
                          highFive: state.highFive
                        };
                });
    }
  };
  var props = ProfileTypesCobra$LiteracyplanetClientSxEntry.makeProps(state, hasFlag);
  var props$1;
  switch (cbState.thumbsUp) {
    case "NotCalled" :
        props$1 = props;
        break;
    case "Failed" :
        var newrecord = Caml_obj.obj_dup(props);
        newrecord.thumbsUpPayload = {
          status: "ERROR"
        };
        props$1 = newrecord;
        break;
    case "Ok" :
        var newrecord$1 = Caml_obj.obj_dup(props);
        newrecord$1.thumbsUpPayload = {
          status: "OK"
        };
        props$1 = newrecord$1;
        break;
    
  }
  var props$2;
  switch (cbState.highFive) {
    case "NotCalled" :
        props$2 = props$1;
        break;
    case "Failed" :
        var newrecord$2 = Caml_obj.obj_dup(props$1);
        newrecord$2.highFivePayload = {
          status: "ERROR"
        };
        props$2 = newrecord$2;
        break;
    case "Ok" :
        var newrecord$3 = Caml_obj.obj_dup(props$1);
        newrecord$3.highFivePayload = {
          status: "OK"
        };
        props$2 = newrecord$3;
        break;
    
  }
  return [
          onProfileSendHighFive,
          onProfileSendThumbsUp,
          props$2
        ];
}

var zIndex = Css.style({
      hd: Css.zIndex(1000),
      tl: {
        hd: Css.position(Css.absolute),
        tl: {
          hd: Css.left(Css.px(0)),
          tl: {
            hd: Css.top(Css.px(0)),
            tl: {
              hd: Css.width({
                    NAME: "percent",
                    VAL: 100.0
                  }),
              tl: {
                hd: Css.height({
                      NAME: "percent",
                      VAL: 100.0
                    }),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var onDispatch = {
  contents: {
    onPreloaderReady: (function () {
        
      }),
    onFailed: (function (param) {
        
      }),
    onExit: (function () {
        
      }),
    onProfileReady: (function () {
        
      }),
    onProfileSendHighFive: (function (param) {
        return Promise.resolve();
      }),
    onProfileSendThumbsUp: (function (param) {
        return Promise.resolve();
      })
  }
};

function ProfileContainer$Cobra(props) {
  var match = Error$LiteracyplanetClientErrors.Consumer.use();
  var onSetError = match.onSetError;
  var match$1 = useSocialCallbacks(props.userId, props.state);
  onDispatch.contents = {
    onPreloaderReady: (function () {
        
      }),
    onFailed: (function (err) {
        onSetError(Error$LiteracyplanetClientErrors.JsInterop.makeError({
                  TAG: "ErrorWithMessage",
                  _0: "Failure in Cobra Profile Modure",
                  _1: undefined
                }, err));
      }),
    onExit: props.resetProfile,
    onProfileReady: (function () {
        
      }),
    onProfileSendHighFive: match$1[0],
    onProfileSendThumbsUp: match$1[1]
  };
  return React.createElement("div", {
              className: zIndex
            }, React.createElement(CobraContainer$LiteracyplanetClientFlags.make, {
                  view: "profile",
                  props: match$1[2],
                  onDispatch: onDispatch
                }));
}

var Cobra = {
  make: ProfileContainer$Cobra
};

function ProfileContainer(props) {
  var resetProfile = props.resetProfile;
  var userId = props.userId;
  return React.createElement(ProfileData$LiteracyplanetClientSxEntry.make, {
              isMe: props.isMe,
              userId: userId,
              children: (function (state) {
                  return React.createElement(ProfileContainer$Cobra, {
                              state: state,
                              userId: userId,
                              resetProfile: resetProfile
                            });
                })
            });
}

var make = ProfileContainer;

export {
  defaultCb ,
  useSocialCallbacks ,
  zIndex ,
  onDispatch ,
  Cobra ,
  make ,
}
/* zIndex Not a pure module */
